import { LeadForm } from "@/components/demo-request/LeadForm";
import { MaxWidthWrapper } from "@/components/maxWidthWrapper";
import { NavLogo } from "@/components/navLogo";

export default function DemoRequestPage() {
  return (
    <div className="min-h-screen bg-background">
      <MaxWidthWrapper>
        <div className="isolate px-6 py-24 sm:py-32 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <div className="mb-8 flex justify-center">
              <a href="/">
                <NavLogo className="h-auto w-52 pr-8 text-primary" />
              </a>
            </div>
            <h2 className="pb-4 text-4xl font-semibold tracking-tight text-balance text-primary sm:text-5xl">
              Request a Demo
            </h2>
            <p className="text-lg text-foreground">
              See how Flash's biometric verification system can add revenue and value to your
              platform.
            </p>
            <p className="text-md pt-16 pb-2 text-muted-foreground">
              A Flash representative will reach out to schedule your personalized demo.
            </p>
          </div>
          <LeadForm />
        </div>
      </MaxWidthWrapper>
    </div>
  );
}
